import { gql } from '@apollo/client';
import Fragments from './fragments';

// TODO: THIS IS NOT WORKING, THIS DO NOT RESPECT THE ENFORCEMENTS
/*
Enforcements for projects that are going to integrate with this composite:

-> all GQLs must implement minimum schema that is in the Gql Main
-> all GQLs must publish the same topics in redisPubSub.js
-> REST APIs must return what GQL Main expect in schema
*/
export const PARAMETER_LIST_QUERY = gql`
  query initializationParameters {
    initializationParameters {
      ...initializationParameterItem
    }
  }
  ${Fragments.initializationParameterItem}
`;
